import styled, { css } from 'styled-components';
import { Icon } from '../../atoms';
import NotificationItem from './NotificationItem';
import buildClassName from '../../../utils/buildClassName';
import { useEffect, useState } from 'react';
import { NotificationModel } from '../../../models/notification.model';
import { useDispatch, useSelector } from 'react-redux';
import { setNotificationUnradCount } from '../../../store/actions/notification/NotificationActions';
import { RootStore } from '../../../store/Store';
import { GET_NOTIFICATION } from '../../../api-calls';
import { useTranslation } from 'react-i18next';

interface OwnStyledProps {
  show?: boolean;
}
interface OwnProps extends OwnStyledProps {
  onClose: () => void;
}
/**
 * Styled Elements
 */
const WrapperDivHGash = styled.div`
  height: 0;
  overflow: hidden;
  display: flex;
  flex-flow: row wrap;
  width: 327px;
  min-height: 1px;
  position: absolute;
  left: -20px;
  top: 42px;
  background-color: ${(theme) => theme.theme.bgColor2};
  /*Animation*/
  -webkit-transition: height 0.3s ease;
  -moz-transition: height 0.3s ease;
  -o-transition: height 0.3s ease;
  transition: height 0.3s ease;
  &.active {
    z-index: 5;
    overflow: visible;
    height: 450px;
    border-bottom-right-radius: 12px;
  }
`;
const NotificationListASDas = styled.div<OwnStyledProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  direction: ${(props) => (props.dir === 'rtl' ? 'right' : 'left')};
  height: calc(100% - 85px);
  overflow-y: scroll;
  opacity: 0;
  transition: opacity 0.5s ease-in;
  ${(p) =>
    p.show &&
    css`
      opacity: 1;
    `}
`;
/**
 * Styled NotificationPanelHeadersdasdAS
 */
const NotificationPanelHeadersdasdAS = styled.div`
  padding: 10px 20px;
  width: 100%;
  display: flex;
  margin-bottom: 16px;
  justify-content: space-between;
  span {
    font-size: 16px;
    color: ${(theme) => theme.theme.bgText};
  }
`;
const HidePanelasDSADas = styled.div`
  font-size: 12px;
  color: ${(theme) => theme.theme.bgRed};
`;
const HidePanelasDSADasWrapper = styled.div`
  cursor: pointer;
  display: flex;
  width: 80px;
  height: 28px;
  justify-content: space-around;
  align-items: center;
  background: rgba(248, 73, 96, 0.05);
  border-radius: 8px;
`;

/**
 * Main Ui CM
 * @constructor
 */
const NotificationDropDown: React.FC<OwnProps> = ({
  show = false,
  onClose,
}) => {
  const [notifList, setNotifList] = useState<NotificationModel[]>([]);
  const NotificationState = useSelector(
    (state: RootStore) => state.notification,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (!show) {
      return;
    }
    const getNotif = () => {
      GET_NOTIFICATION().then(
        (res) => {
          dispatch(setNotificationUnradCount(res.data.data.unseenCount));
          let list: any[] = [];
          res.data.data.content.map(
            (item: NotificationModel, index: number) => {
              list.push(
                <NotificationItem
                  key={item.id}
                  title={item.title}
                  message={item.message}
                  seen={item.seen}
                  id={item.id}
                  date={item.creationTime}
                  hasRadius
                  hasSeparator
                ></NotificationItem>,
              );
            },
          );
          setNotifList(list);
        },
        (error) => {},
      );
    };
    getNotif();
    return () => {
      setNotifList([]);
    };
  }, [show]);

  const {t, i18n} = useTranslation();
  const lng = i18n.language;

  return (
    <WrapperDivHGash onClick={(e) => e.stopPropagation()} className={buildClassName(show && 'active')}>
      <NotificationPanelHeadersdasdAS>
        <span>{t("dashboard.notification.title")}</span>
        <HidePanelasDSADasWrapper onClick={onClose}>
          <HidePanelasDSADas>{t("dashboard.notification.hide")}</HidePanelasDSADas>
          {/* <Icon name="arrowredleft" width="12.5px" height="15px" /> */}
          { lng === "fa" ? 
          (<Icon name="arrowredleft" width="12.5px" height="15px" />)
          :
          (<Icon name="arrowredleften" width="12.5px" height="15px" />)
        }
        </HidePanelasDSADasWrapper>
      </NotificationPanelHeadersdasdAS>
      <NotificationListASDas className="custom-scroll" show={show}>
        {notifList}
      </NotificationListASDas>
    </WrapperDivHGash>
  );
};

export default NotificationDropDown;
